export default class CustomerServiceContact {
	constructor() {
		const categorySelect = document.getElementById(
			'customerServiceContactCategorySelect',
		);

		if (categorySelect) {
			new window.od.OdSelect(categorySelect, { searchEnabled: false });
			this.attachBemClass();
		}
	}

	attachBemClass() {
		const outerContainer = document.querySelector('[data-type=select-one]');
		outerContainer.classList.add(
			'customer-service-contact-form__category-od-select',
		);
	}
}
